'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useState } from 'react';
import Button from '../Button/index.js';
import { ButtonViewMoreWrapper } from './ButtonViewMore.css.js';
import ThreeDotIcon from '../Images/ThreeDotIcon/index.js';
import { DEFAULT_STYLE_OTPIONS, DEFAULT_TEXT_OPTIONS } from './constants.js';
import ResponsiveSheet from './components/ResponsiveSheet/index.js';
import DesktopSheet from './components/DesktopSheet/index.js';
import useFloating from '../hooks/useFloating/index.js';
import '../hooks/useMakeSearchable/types.js';
import '../Utils/constants.js';
import '../services/resumes/types.js';
import { createPortal } from 'react-dom';

var ButtonViewMore = function (props) {
    var options = props.options, styleOptions = props.styleOptions, textOptions = props.textOptions, icon = props.icon, onClick = props.onClick, _a = props.mode, mode = _a === void 0 ? 'vertical' : _a, header = props.header;
    var mergedStyleOptions = __assign(__assign({}, DEFAULT_STYLE_OTPIONS), styleOptions);
    var mergedTextOptions = __assign(__assign({}, DEFAULT_TEXT_OPTIONS), textOptions);
    var _b = useState(false), isShow = _b[0], setIsShow = _b[1];
    var _c = useFloating({
        placement: mergedStyleOptions.displayAlign === 'right' ? 'bottom-end' : 'bottom-start'
    }), context = _c.context, refs = _c.refs;
    var isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : true;
    return (React__default.createElement(ButtonViewMoreWrapper, { onClick: function (e) { return onClick === null || onClick === void 0 ? void 0 : onClick(e, isShow); } },
        React__default.createElement(Button, { "aria-label": 'button-view-more', key: "rounded-".concat(isMobile), type: mergedStyleOptions.button.type, size: mergedStyleOptions.button.size, outline: mergedStyleOptions.button.outline, isIcon: mergedStyleOptions.button.isIcon, isRounded: mergedStyleOptions.isRounded, onClick: function () { return setIsShow(true); }, ref: refs.setReference }, icon || React__default.createElement(ThreeDotIcon, null)),
        isShow &&
            isMobile &&
            createPortal(
            // we insert sheet on document body to prevent z-index issue of nested parent element
            React__default.createElement(ResponsiveSheet, { isShow: true, mode: mode, sheetStyles: { zIndex: 10001 }, setIsShow: setIsShow, options: options, header: header, textOptions: mergedTextOptions, responsiveButton: mergedStyleOptions.responsiveButton }), document === null || document === void 0 ? void 0 : document.body),
        isShow && !isMobile && (React__default.createElement(DesktopSheet, { displayAlign: mergedStyleOptions.displayAlign, isShow: true, mode: mode, setIsShow: setIsShow, options: options, context: context, customPadding: mergedStyleOptions.customPadding, ref: refs.setPopup }))));
};

export { ButtonViewMore as default };
//# sourceMappingURL=index.js.map
